import { motion } from 'framer-motion';
import { React, useEffect, useState } from "react";
import DataTable from 'react-data-table-component';
import { useSelector } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import Popup from 'reactjs-popup';
import EmailDetailUserModal from '../../Components/Admin/Components/Users/User/MessageContainer/SendEmail/Modals/EmailDetailUserModal';
import TextDetailUserModal from '../../Components/Admin/Components/Users/User/MessageContainer/SendText/Modals/TextDetailUserModal';
import { permissions } from "../../Store/reducers/PermissionsReducer";
import ResetPassword from '../../Util/DataTable/ModalContentAdmin/ResetPassword/ResetPassword';
import close from "../../assets/close.svg";
import { BACK_DROP_FALSE, getUrlToPush } from "../helper";
import "./DataTable.css";
import ModalContentAdmin from "./ModalContentAdmin/ModalContentAdmin";
import ModifyAccount from "./ModalContentAdmin/common/ModifyAccount";
import ModalContentEmployee from "./ModalContentEmployee/ModalContentEmployee";
import ModalContentUser from "./ModalContentUser/ModalContentUser";


const DataTableComponent = (props) => {
  const permission = useSelector(permissions) || [];
  const [open, setOpen] = useState(false);
  const [modify, setModify] = useState(false);
  const [modalContent, setModalContent] = useState(<ModalContentUser />);
  const [selectedUser, setSelectUser] = useState([]);
  const [subTitle, setSubTitle] = useState(false);
  const [resetPassWord, setResetPassword] = useState(false);
  const [archiveModel, setArchiveModel] = useState(false);
  // const [contactUsModel, setContactUsModel] = useState(false);
  const [data, setData] = useState([]);
  const history = useHistory();
  const customStyles = {
    rows: {
      style: {
        minHeight: '0',
        cursor: !props.disableRowClicked ? 'pointer' : '',
      }
    },
    header: {
      style: {
        fontSize: '22px',
        color: 'blue',
        backgroundColor: 'blue',
        minHeight: '56px',
        paddingLeft: '16px',
        paddingRight: '8px',
      },
    },
    subHeader: {
      style: {
        backgroundColor: 'blue',
        minHeight: '52px',
      },
    },
    headCells: {
      style: {
        fontSize: '13px',
        fontWeight: 500,
        color: 'white',
        backgroundColor: 'var(--primary-color)',
        '&:hover': {
          color: 'white',
          cursor: 'pointer'
        },
        '&:focus': {
          color: 'white',
        }
      },
      activeSortStyle: {
        color: 'white',
        '&:focus': {
          color: 'white',
        },
        '&:hover': {
          color: 'white',
        }
      }
    }
  };
  const closeModal = (resp) => {
    setModify(false);
    setResetPassword(false);
    if (resp && props.refresh) {
      setOpen(o => !o);
      props.refresh();
    }
  }

  useEffect(() => {
    setData(props.data);
  }, [props.data])



  useEffect(() => {
    setModalContent(loadModalContent());
    //eslint-disable-next-line
  }, [modify, resetPassWord]);

  const rowPreExpanded = row => row.defaultExpanded


  /**** Loads Modal Content ******/
  const loadModalContent = () => {
    if (modify) {
      return (
        <ModifyAccount
          type={props.type}
          data={selectedUser}
          closeModal={
            (updatedUser) => {
              if (open) {
                setSelectUser(updatedUser);
                if (props.refresh) {
                  props.refresh();
                }
                closeModal(false);
              } else {
                setModify(false)
              }
            }
          }
          currentModifyPage={currentModifyPage}
        />
      );
    } else {
      if (['admin', 'employee', 'user'].includes(props.type)) {
        const modalContent = {
          admin: <ModalContentAdmin userData={selectedUser} type={'admin'} />,
          employee: <ModalContentEmployee userData={selectedUser} type={'employee'} resetPassword={openResetPopUpPass} />,
          user: <ModalContentUser data={selectedUser} />,
        }
        return modalContent[props.type];
      }
    }
  }

  const noDataConst = <div className="noRecord-found">{!props.loading && 'No Record Found'}</div>;

  const currentModifyPage = (page) => {
    setSubTitle(page);
  }

  const openResetPopUpPass = (resp = false) => {
    setResetPassword(resp)
  }
  return <motion.div>

    <DataTable
      columns={props.columns}
      data={data}
      paginationPerPage={props.limit || 50}
      onRowClicked={(data) => {
        if (!props.disableRowClicked) {
          if (!props.copy) {
            if (['user', 'admin', 'employee'].includes(props.type)) {
              setOpen(o => !o)
              setSelectUser(data);
              if (props.type === 'user') {
                setModalContent(<ModalContentUser data={data} resetPassword={openResetPopUpPass} reloadListing={() => {
                  if (props.refresh) {
                    props.refresh();
                  }
                }} />);
              } else if (props.type === 'admin') {
                setModalContent(<ModalContentAdmin type={'admin'} userData={data} resetPassword={openResetPopUpPass} />)
              } else {
                setModalContent(<ModalContentEmployee type={'employee'} closeModal={closeModal} userData={data} resetPassword={openResetPopUpPass} />)
              }
            } else if (['email', 'text'].includes(props.type)) {
              setOpen(o => !o)
              setArchiveModel(true);
              setSelectUser(data);
            } else if (['contact-us'].includes(props.type)) {

            } else if (['league_groups', 'league_team_info'].includes(props.type)) {
              if (props.type === 'league_team_info') {
                history.push({
                  pathname: `/admin/leagues/LeagueGroups/TeamInfo/${data.league_id}/${data.id}`,
                  search: `${(props?.season_id) ? `?season_id=${props.season_id}` : ''}`,
                });
              } else {
                return history.push({
                  pathname: getUrlToPush(props.type),
                  season_name: props?.selectedSeason?.season_name,
                  search: `?leagueId=${data.id}${(props?.selectedSeason?.season_id) ? `&season_id=${props.selectedSeason.season_id}` : ''}`,
                  state: {
                    season_id: props?.selectedSeason?.season_id,
                    season_name: props?.selectedSeason?.season_name,
                  }
                });
              }
            } else if (props.type === 'season_league_team_info') {
              history.push(`/admin/leagues/individual-registrations/TeamInfo/${data.league.id}/${data.id}`);
            } else if (props.type === 'templates') {
              history.push(`/admin/settings/templates/edit-template/${data.id}`);
            } else if (props.type === 'teamPlayer') {
              props.openPlayer(data);
            } else if (props.type === 'addPlayer') {
              props.addPlayer(data);
            } else if (['coupons'].includes(props.type)) {
              return history.push(`/admin/coupons/${data.id}`)
            } else if (['leads'].includes(props.type)) {
              return history.push(`/admin/events/leads/edit/${data?.id}`);
            } else if (['documents'].includes(props.type)) {
              return history.push(`/admin/events/documents/edit/${data?.id}`);
            } else if (['events'].includes(props.type)) {
              return history.push(`/admin/events/edit/${data?.id}`);
            } else if (['public-events'].includes(props.type)) {
              return history.push(`/admin/events/edit/${data?.id}?ticket=true`);
            } else if (['tickets'].includes(props.type)) {
              props.showTicket(data);
            } else {
              history.push(getUrlToPush(props.type, data?.champion_id));
            }
          }
          else if (props.type === 'season_league_team_info') {
            history.push(`/admin/leagues/individual-registrations/TeamInfo/${data.league_id}/${data.id}`);
          } else if (props.type === 'teamPlayer') {
            props.openPlayer(data);
          } else if (props.type === 'addPlayer') {
            props.addPlayer(data.id);
          } else {
            if (props.handleConditionalStyle) {
              props.handleConditionalStyle(data);
            }
          }
        }
      }}
      key={`datatable-index${props.type || 0}`}
      customStyles={customStyles}
      noDataComponent={noDataConst}
      paginationServer={true}
      paginationServerOptions={{ persistSelectedOnPageChange: false, persistSelectedOnSort: false }}
      onChangePage={(pageChange) => {
        props.onFilterChange({
          target: {
            name: 'page',
            value: pageChange,
          }
        });
      }}
      onChangeRowsPerPage={(page) => {
        props.onFilterChange({
          target: {
            name: 'limit',
            value: page,
          }
        });
      }}
      paginationTotalRows={props.totalPage}
      persistTableHead={true}
      pagination={props.totalPage && props.totalPage > (props?.limit || 50) ? true : false}
      sortServer={true}
      onSort={
        (columns, direction) => {
          props.onFilterChange({
            target: {
              name: 'sort_column',
              value: (columns.selector() === 'getDate' || columns.selector() === 'getTime') ? 'created_at' : (columns.selector() === 'getPlainText' ? 'message' : columns.selector()),
              direction: direction,
            },
            type: 'sort',
          })
        }
      }
      conditionalRowStyles={props.conditionalRowStyles || {}}
      noTableHead={props.noTableHead || false}
      expandableRows={props?.expandableRows ? true : false}
      expandableRowsComponent={props?.expandableRowsComponent}
      expandableRowExpanded={rowPreExpanded}
      paginationRowsPerPageOptions={[10, 20, 50, 100, 200]}
    />
    <Popup open={open} closeOnDocumentClick={BACK_DROP_FALSE} onClose={closeModal} className={props.type === 'user' ? `usersEdit` : ''}>
      {
        (
          resetPassWord
            ? (

              <ResetPassword closeModal={() => setResetPassword(false)} data={selectedUser} />
            )
            : (archiveModel ? (props.type === 'email' ? <EmailDetailUserModal hideArchBtn={(e) => props.hideArchBtn(e)} data={selectedUser} closeModal={() => setOpen(o => !o)} /> : <TextDetailUserModal hideArchBtn={(e) => props.hideArchBtn(e)} data={selectedUser} closeModal={() => setOpen(o => !o)} />) : (
              <div className="modal">
                <div className="modal-header">
                  {
                    props.type ? (
                      <>
                        <h2>
                          {
                            modify
                              ?
                              (
                                `Modify ${{ admin: 'Administrator', user: 'User', employee: 'Employee' }[props.type]}`
                              )
                              : 'Account Details'
                          } - {selectedUser.first_name} {selectedUser.last_name}
                        </h2>
                        {
                          modify
                            ?
                            (
                              <p>{subTitle ? 'Select account priviliges' : 'Enter account info'}</p>
                            )
                            : (
                              <p>View Info {(permission.includes('users_modify_admin') || permission.includes('users_modify_employee')) && <> or <span onClick={() => setModify(true)}>Modify Account</span></>}</p>
                            )
                        }
                      </>
                    ) :
                      (<>
                        <h2>Email Details</h2>
                        <p>Sent 6/2/2021 at 4:15 PM</p>
                      </>)
                  }
                  <span className="close" onClick={() => setOpen(o => !o)}>
                    <img src={close} alt='close-img' />
                  </span>
                </div>
                {modalContent}
                {!modify &&
                  <div className="modal-footer d-flex">
                    <button onClick={() => setOpen(o => !o)}>Close</button>
                  </div>
                }
              </div>
            ))
        )
      }
    </Popup>
  </motion.div>
}

export default withRouter(DataTableComponent);